


















































































































































































































































import CampaignApi from '@/services/rest/bemob/campaign';
import {Component, Prop, Watch} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { cloneDeep, debounce, flatten, throttle } from 'lodash';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import Form, { Send, TranslateErrorsOptions } from '@/components/form-base';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';

import LandingApi from '@/services/rest/bemob/landing';
import OfferApi from '@/services/rest/bemob/offer';
import FlowApi from '@/services/rest/bemob/flow';
import TagApi from '@/services/rest/bemob/tag';

import formMock from './config/form-mock';
import macroMock from './config/macro-mock';

import tutorial from '@/components/tutorial/tutorial';

import BasicHelperMixin from '@/components/helpers/basic-helper-mixin';
import ConstantsHelperMixin from '@/components/helpers/constants-helper-mixin';
import FlowMixin from '@/views/reports/forms/flow/mixins/flow-mixin';

import CreateCampaignDialogPanelOne from './components/create-campaign-dialog-panel-one.vue';
import CreateCampaignDialogFlowPreview from './components/create-campaign-dialog-flow-preview.vue';
import CreateCampaignDialogFlowRule from './components/create-campaign-dialog-flow-rule.vue';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import { ErrorParseMethodEnum } from '@/services/models/Enums';
import FlowPathErrorsMixin from '@/views/reports/forms/flow/mixins/flow-path-errors-mixin';
import MenuReportDialogsMixin from '@/views/layout/navigation/mixins/menu-report-dialogs-mixin';
import WorkspaceSelect from '@/views/reports/pickers/wokrspace-select.vue';
import ReportMixin from '@/views/reports/mixins/report-mixin';
import CampaignTutorialMixin from '@/views/reports/forms/campaign/config/campaign-tutorial-mixin';
import ApiServices from '@/services';
import reportUtils from '@/views/reports/report-utils';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import OffersLandingsSelectOptionsMixin from '@/views/reports/mixins/flow/offers-landings-select-options-mixin';
import CreateCampaignDialogCountryMixin from '@/views/reports/mixins/flow/create-campaign-dialog-country-mixin';
import TrafficSource from '@/services/rest/bemob/traffic-source';
import Vue from 'vue';
import DomainsApi from '@/services/rest/bemob/domains';

const md5 = require('md5');

@Component({
  components: {
    FormOverlay,
    DialogForm,
    ErrorAggregator,
    CreateCampaignDialogPanelOne,
    CreateCampaignDialogFlowPreview,
    CreateCampaignDialogFlowRule,
    HeaderButtons,
    FlowPathErrorsMixin,
    WorkspaceSelect
  }
})
export default class CreateCampaignDialog extends mixins(
  Form, 
  ReportMixin, 
  MenuReportDialogsMixin, 
  CampaignTutorialMixin,  
  mixins(
    BasicHelperMixin,
    ConstantsHelperMixin,
    FlowMixin,
    OffersLandingsSelectOptionsMixin,
    mixins(
      PlanLimitsMixin,
      CreateCampaignDialogCountryMixin
    )
  )
) {

  @Prop({ default: {} })
  data: any;

  show: boolean = false;
  edit: boolean = false;

  campaignApi: CampaignApi = new CampaignApi();
  landingApi: LandingApi = new LandingApi();
  offerApi: OfferApi = new OfferApi();
  tagApi: TagApi = new TagApi();
  trafficSourceApi: TrafficSource = new TrafficSource();
  flowApi: FlowApi = new FlowApi();
  domainsApi: DomainsApi = new DomainsApi();
  step: number = 1;
  loading: boolean = false; 
  selectTrackingDomain: any = [];
  currentOffersCount: number = 0;
  lastTrackingDomainId: string = '';
  form: any = this.defaultForm();
  placeholder: boolean = true;
  chips: any[] = [];
  campaign_id: any = '';
  flowOptions: Flow[] = []
  offerOptions: Offer[] = []
  landingOptions: Landing[] = []

  reportUtils = reportUtils(this);

  errorsControlActive: boolean = false;
  errorMessage: string = '';
  errorsRaw: any = null;
  campaignInitialState: Campaign = {};

  get errors() {
    return this.errorsRaw
      ? this.translateErrors(this.errorsRaw, this.errorMessage, this.translateErrorsConfig)
      : [];
  }

  get modalTitle(){
    return this.t('Create Campaign')
  }

  emptyUrlSend: boolean = false;

  flowInlineRenderedOnce: boolean = false;

  @Watch('form.destinationType', {immediate: true})
  onFormDestinationTypeChanged(value: string) {
    if(value === 'flowInline' && !this.flowInlineRenderedOnce) {
      this.flowInlineRenderedOnce = true;
    }
  }
  
  get destinationUrl() {
    return this.form.destinationUrl
  }

  set destinationUrl(val) {
    this.form = {
      ...this.form,
      destinationUrl: val
    }
  }

  destinationTypeChange(){
    this.form.destinationUrl = '';
    this.$set(this.form,'flow',null)
    this.form.rotation = this.rotationOptions[0].key;
    this.form.flowInline= {
      ...formMock().flowInline
    }
  }

  oldHash: string = '';
  getCurrentHash() {
    return md5(JSON.stringify(this.form));
  }

  get isActionsDisabled() {
    return !!(this.edit && this.aclReadOnly({
      workspaceId: this.form.workspaceId,
      id: this.campaign_id
    }));
  }

  get convertToFlowDisabled() {
    return this.form.rotation!=='random'
  }

  get translateErrorsConfig(): TranslateErrorsOptions {
    let translate: any = {
      flowId: {
        VALIDATION_INVALID_VALUE: 'CUSTOM_VALIDATION_FLOW_SHOULD_BE_SELECTED'
      }
    };

    if(this.emptyUrlSend) {
      translate['destinationUrl'] = {
        VALIDATION_INVALID_URL: 'CUSTOM_VALIDATION_EMPTY_URL'
      }
    }

    return { translate };
  }

  async mounted() {
    this.campaign_id = this.data.id || this.$store.getters.selectedItem.id;

    this.chips = macroMock().map(e => {
      return {
        tag: e,
        disabled: false
      }
    });

    this.$on('error', (e: any, payload: any) => {
      this.$store.commit('loading', false);

      this.errorsRaw = this.parseErrors(e.data.errors, ErrorParseMethodEnum.numerate);
      this.errorMessage = e.data.message;
      this.errorsControlActive = true;
    });

    this.subscribeEventBus();

    this.$store.commit('loading', true);

    await this.load();

    if(!this.$store.state.cache.trafficSources.isUploaded){
      await this.trafficSourceApi.populateStoreCache()
    }

    if(!this.$store.state.cache.flows.isUploaded){
      await this.flowApi.populateStoreCache()
    }

    if(!this.$store.state.cache.landings.isUploaded){
      await this.landingApi.populateStoreCache()
    }

    if(!this.$store.state.cache.offers.isUploaded){
      await this.offerApi.populateStoreCache()
    }

    if(!this.$store.state.cache.trackingDomains.isUploaded){
      await this.domainsApi.trackingDomainsPopulateStoreCache()
    }

    if(!this.$store.state.cache.redirectDomains.isUploaded){
      await this.domainsApi.redirectDomainsPopulateStoreCache()
    }

    if(!this.$store.state.cache.tags.campaigns.isUploaded){
      await this.tagApi.populateStoreCache({type:'campaigns'})
    }
 
    this.$store.commit('loading', false);
    this.tutorial.form();
    this.show = true
    this.setFlowOptions()
    this.setLandingOptions()
    this.setOfferOptions()
  }

  setFlowOptions() {
    const {uploadedForWorkspace, uploadedForCountryId, isAllInCache, data, isUploaded} = this.$store.state.cache.flows;
    if(isUploaded && isAllInCache) {
      return this.flowOptions = data.filter(item => (this.$store.getters.allPublicWorkspacesIds.includes(item.workspaceId) || item.workspaceId === this.form.workspaceId) &&   this.countryCondition({ form:this.form,item, id:this.campaignInitialState.flow?.id })  )
    }

    if(isUploaded && !isAllInCache && uploadedForWorkspace === this.form.workspaceId && uploadedForCountryId === this.form.countryId){
      return this.flowOptions = [...data]
    }


    if(this.form.workspaceId === this.defaultWorkspace.id && this.form.countryId === 0){
      return this.flowApi.updateStoreCache({
        workspaceId: this.defaultWorkspace.id,
        countryId: 0
      }).then((res:Flow[])=>{
        this.flowOptions = res
      })
    }
    return this.flowApi.getList({
      status:'active',
      limit:'200',
      orderBy:'updated',
      orderDirection:'desc',
      columns:['name', 'nameFull', 'id', 'countryId', 'workspaceId'],
      workspaceId:this.form.workspaceId,
      ...(this.form.countryId!==0 && {countryId:this.form.countryId})
    }).then((res:Flow[])=>{
      this.flowOptions = res
    })
  }
 
  get fetchFlowOptions(){
    if(this.$store.state.cache.flows.isAllInCache){
      return
    }
    return ({ search })=>this.flowApi.getList({
      search:search,
      status:'active',
      limit:'200',
      orderBy:'updated',
      orderDirection:'desc',
      columns:['name', 'nameFull', 'id', 'countryId', 'workspaceId'],
      workspaceId:this.form.workspaceId
    })
  }
  
  onBusIntroJsOnbeforechange(introJsInstance: any, cb: Function) {
    if(this.isCurrentTutorial && this.$store.state.tutorial.quickStartStep) {
      if(this.form.destinationType !== 'url' && introJsInstance._currentStep === 3) {
        const direction = introJsInstance._direction;
        this.$nextTick(() => {
          if(direction === 'forward') {
            introJsInstance.goToStepNumber(6);
          } else  {
            introJsInstance.goToStepNumber(4);
          }
        });
        
        cb(false);
      }
    }
  }

  onBusCampaignDeleteLanding(ruleIndex: number, pathIndex: number, landingIndex: number) {
    if(this.errorsRaw) {
      const flowPathErrorsMixin = this.$refs.flowPathErrorsMixin as FlowPathErrorsMixin;

      let errors = flowPathErrorsMixin.processLandingError(ruleIndex, pathIndex, landingIndex);
      this.errorsRaw = flowPathErrorsMixin.fixLandingErrorIndexes(ruleIndex, pathIndex, landingIndex, errors);
    }
  }

  onBusCampaignDeleteOffer(ruleIndex: number, pathIndex: number, offerIndex: number) {
    if(this.errorsRaw) {
      const flowPathErrorsMixin = this.$refs.flowPathErrorsMixin as FlowPathErrorsMixin;

      let errors = flowPathErrorsMixin.processOfferError(ruleIndex, pathIndex, offerIndex);
      this.errorsRaw = flowPathErrorsMixin.fixOfferErrorIndexes(ruleIndex, pathIndex, offerIndex, errors);
    }
  }

  onBusCampaignCampaignDeleteRule(ruleIndex: any) {
    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      message: this.t('All selected items will be deleted permanently if you press OK.'),
      onConfirm: () => {
        if(this.errorsRaw) {
          const flowPathErrorsMixin = this.$refs.flowPathErrorsMixin as FlowPathErrorsMixin;

          const errors = flowPathErrorsMixin.processRuleError(ruleIndex);
          this.errorsRaw = flowPathErrorsMixin.fixRuleErrorIndexes(ruleIndex, errors);
        }

        this.form.flowInline.rules.splice(ruleIndex, 1);
      },
    }})
  }

  onBusCampaignCampaignDeletePath(ruleIndex: any, pathIndex: number) {
    const rule = this.form.flowInline.rules[ruleIndex];

    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      message: this.t('All selected items will be deleted permanently if you press OK.'),
      onConfirm: () => {
        if(this.errorsRaw) {
          const flowPathErrorsMixin = this.$refs.flowPathErrorsMixin as FlowPathErrorsMixin;

          let errors = flowPathErrorsMixin.processPathError(ruleIndex, pathIndex);
          this.errorsRaw = flowPathErrorsMixin.fixPathErrorIndexes(ruleIndex, pathIndex, errors);
        }
        rule.paths.splice(pathIndex, 1);
      },
    }})
  }

  onBusCampaignNewLanding() {
    this.bus.emit('open-dialog', { 
      name: 'CreateLanding',
      data: {
        workspaceId:this.form.workspaceId,
        onClose: this.setLandingOptions 
      }
    });
  }

  onBusCampaignEditLanding(id: string) {
    this.bus.emit('open-dialog', { name: 'EditLanding', data: { 
        id,
        onEdit: this.updateLanding
      } 
    });
  }

  onBusCampaignNewOffer() {
    this.bus.emit('open-dialog', {
      name: 'CreateOffer', 
      data: { 
        workspaceId:this.form.workspaceId,
        onClose: this.setOfferOptions
      }
    });
  }

  onBusCampaignEditOffer(id: string) {
    this.bus.emit('open-dialog', { name: 'EditOffer', data: {
        id,
        onEdit: this.updateOffer
      }
    });
  }


  updateLanding(updatedLanding: any) {
    let index = this.landingOptions.findIndex((item: any) => item.id === updatedLanding.id);
    this.$set(this.landingOptions, index, updatedLanding);

    // update selected landings in form
    this.form.flowInline.rules.forEach((rule,ruleIndex)=>{
      rule.paths.forEach((path,pathIndex)=>{
        path.landings.forEach((landing,landingIndex)=>{
          if(landing.id===updatedLanding.id){
            this.form.flowInline.rules[ruleIndex].paths[pathIndex].landings[landingIndex]={
              ...landing,
              ...updatedLanding
            }
          }
        })
      })
    })
  }

  updateOffer(updatedOffer: any) {
    let index = this.offerOptions.findIndex((item: any) => item.id === updatedOffer.id);
    this.$set(this.offerOptions, index, updatedOffer);

    // update selected offers in form
    this.form.flowInline.rules.forEach((rule,ruleIndex)=>{
      rule.paths.forEach((path,pathIndex)=>{
        path.offers.forEach((offer,offerIndex)=>{
          if(offer.id===updatedOffer.id){
            this.form.flowInline.rules[ruleIndex].paths[pathIndex].offers[offerIndex]={
              ...offer,
              ...updatedOffer
            }
          }
        })
      })
    })
  }

  defaultForm() {
    return {
      ...formMock(),
      currencyId:this.$store.state.user.currencyId,
      rotation: '',
    };
  }

  get isDisabledWeight() {
    return this.rotationOptions[0].key !== this.form.rotation
  }

  get allWorkspaceIds() {
    return [...new Set([this.form.workspaceId,...this.$store.getters.allPublicWorkspacesIds])]
  }

  loadForm() {
    return new Promise((resolve) => {
      resolve({
        ...this.defaultForm(),
        rotation: this.rotationOptions[0].key,
        workspaceId: this.defaultWorkspace.id
      });
    });
  }

  openCreateFlowDialog(){
    const rulesWithUpdatedRedirectMode = this.form.flowInline.rules.map(rule=>{
      return {
        ...rule,
        paths:rule.paths.map(path=>{
          return {
            ...path,
            ...(this.form.redirectMode === 'doubleMeta'&&{
              redirectDomainId: this.form.redirectDomainId,
              redirectDomainIdOffers: this.form.redirectDomainId,
            }),
            redirectMode: this.form.redirectMode,
            redirectModeOffers: this.form.redirectMode
          }
        })
      }
    })

    this.bus.emit('open-dialog', {
      name: 'CreateFlow',
      data: {
        createFromConvertToFlow:true,
        form:{
          workspaceId:this.form.workspaceId,
          rules:rulesWithUpdatedRedirectMode
        },
        onConfirm:(flow)=>{
          this.flowOptions.unshift(flow)
          this.form.destinationType = 'flow';
          this.form.flow = flow
        }
      }
    });
  }


  updateFlow(updatedFlow:Flow){
    this.flowOptions = this.flowOptions.map((item:Flow)=>{
      if(item.id === updatedFlow.id){
        return updatedFlow
      }
      return item
    })
    
    if(this.form.flow.id===updatedFlow.id){
      Vue.set(this.form, 'flow', {...updatedFlow});
    }
  }

  async load() {
    this.campaign_id = ''
    const campaign: any = await this.loadForm();

    this.form = {
      ...campaign,
    };
    this.oldHash = this.getCurrentHash();
  }
  
  subscribeEventBus(){
    this.bus.on('campaign-delete-rule', this.onBusCampaignCampaignDeleteRule);

    this.bus.on('campaign-delete-path', this.onBusCampaignCampaignDeletePath);

    this.bus.on('campaign-new-landing', this.onBusCampaignNewLanding);
    this.bus.on('campaign-edit-landing', this.onBusCampaignEditLanding);
    this.bus.on('campaign-delete-landing', this.onBusCampaignDeleteLanding);

    this.bus.on('campaign-new-offer', this.onBusCampaignNewOffer);
    this.bus.on('campaign-edit-offer', this.onBusCampaignEditOffer);
    this.bus.on('campaign-delete-offer', this.onBusCampaignDeleteOffer);
    this.bus.on('intro-js-onbeforechange', this.onBusIntroJsOnbeforechange);
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash() && !this.isActionsDisabled) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  close() {
    this.$emit('close');

    // deleteOfferEvent: string = 'campaign-delete-offer';
    // addLandingEvent: string = 'campaign-new-landing';
    // editLandingEvent: string = 'campaign-edit-landing';
    // deleteLandingEvent: string = 'campaign-delete-landing';
    this.bus.off('campaign-delete-rule', this.onBusCampaignCampaignDeleteRule);

    this.bus.off('campaign-delete-path', this.onBusCampaignCampaignDeletePath);

    this.bus.off('campaign-new-landing', this.onBusCampaignNewLanding);
    this.bus.off('campaign-edit-landing', this.onBusCampaignEditLanding);
    this.bus.off('campaign-delete-landing', this.onBusCampaignDeleteLanding);

    this.bus.off('campaign-new-offer', this.onBusCampaignNewOffer);
    this.bus.off('campaign-edit-offer', this.onBusCampaignEditOffer);
    this.bus.off('campaign-delete-offer', this.onBusCampaignDeleteOffer);
    this.bus.off('intro-js-onbeforechange', this.onBusIntroJsOnbeforechange);
  }
 
  changeTrackingDomain(value: any) {
    this.form.trackingDomainId = value;

    if(this.form.trackingDomainId === this.lastTrackingDomainId)
      return false;

    if(this.form.trackingDomainId === null)
      this.form.trackingDomainId = '';

    const trackingDomainId = this.form.trackingDomainId || this.$store.state.user.trackingDomainId

    this.selectTrackingDomain = this.$store.getters.cache.trackingDomainsObject[trackingDomainId];

    this.lastTrackingDomainId = this.form.trackingDomainId;
  }

  addNewRule(rule?: any) {
    this.bus.emit('open-dialog', { name: 'CreateRule', data: { rule, target: this.self } });
  }

  processForm(form: any) {
    let result = cloneDeep(form);

    if (!result.maxCostEnabled || !['auto', 'autoCpm'].includes(result.costModel)) {
      delete result.maxCostEnabled;
      delete result.maxCostUsd;
      delete result.maxCostAction;
      delete result.maxCostBotOfferId;
    } else {
      result.maxCostUsd = Number(result.maxCostUsd) || null;
      if (result.maxCostAction !== 0) {
        delete result.maxCostBotOfferId;
      } else {
        result.maxCostBotOfferId = result.maxCostBotOfferId || null;
      }
    }

    result.sendCustomEventPostback = {
      mode: result.sendCustomConversionMode,
      ...(result.sendCustomConversionMode !== 'all' ? {ids: result.sendCustomConversionIds} : {}),
      doNotSendNotSpecifiedConversions: result.doNotSendNotSpecifiedConversions
    }

    result.trafficSourceId=result.trafficSource.id;
    result.flowId=result.flow?.id || null;
    result.tags=result?.tags?.map((item)=>item?.id ? item.name : item);
     
    delete result.sendCustomConversionMode;
    delete result.sendCustomConversionIds;
    delete result.doNotSendNotSpecifiedConversions;
    delete result.trafficSource;
    delete result.flow;

    if(form.flowInline) {
      result.flowInline.rules.forEach((rule: any) => {
        rule.paths.forEach((path: any) => {
          if(path.directLinking) {
            path.landings = path.landings.filter((item: any) => item.id);
          }
        });
      });
    }
    return result;
  }

  save(){
    this.submit(true);
    this.tutorial.close();
  }
  
  @Send()
  submit(forceOpenLinks: boolean = false) { // need to show campaign links, override on edit
    this.$store.commit('loading', true);

    this.emptyUrlSend = !this.form.destinationUrl;

    const form = this.processForm(this.form);

    return this.campaignApi.postCreate(form).then(async (response) => {
      const { id } = response.data.payload;

      await ApiServices.getUserProfile();

      this.trackAnalytics('campaign_create',form)

      //give backend some time to save changes
      setTimeout(() => {
        this.bus.emit('refresh-report');
        this.bus.emit('toast-success', this.t('Campaign has been saved'));
        this.close();

        if(forceOpenLinks) {
          this.dialogActionsEvents.campaigns.campaignLinks(id);
        }

        this.$store.commit('loading', false);
      }, 1000);
    });
  }
 

  //TODO: find more elegant solution, or enhance existing
  get sectionTwoSelectsScrollFix() {
    return debounce(() => {
      const refs = flatten(
          [
            this.$refs.sectionTwoSelectsFlow,
            this.$refs.sectionTwoSelectsDomain,
            this.$refs.sectionTwoSelectsLandings,
            this.$refs.sectionTwoSelectsOffers
          ] as any[]
        )
        .filter((e: any) => !!e);

      this.fixVuetifySelects(refs);
    }, 10);
  }

  fixVuetifySelects(selectRefs: any) {
    selectRefs.forEach((select: any) => {
      select.$refs.menu.onResize();
    });
  }
 
  get defaultRedirectDomainId() {
    return this.$store.state.user.redirectDomainId;
  }

  getCountryName(countryId: number) {
    let result = '';

    let country = this.countryListPlusGlobal.find((item: any) => item.id === countryId);
    if (country) {
      result = country.name;
    }

    return result
      ? result
      : this.t('Global');
  }

  get countryListPlusGlobal() {
    return this.$store.getters.countryListPlusGlobal;
  }

  get self() {
    return this;
  }

  get tutorial() {
    return tutorial(this);
  }

  getRuleConditions(conditions: any) {
    const item = { conditions };

    if(item) {
      let result = this.generate_name(item, false)

      if (result.length >= 3) {
        result = result.slice(0, 2);
        result.push({
          name: '...',
          elipsis: true
        });
      }

      return result;
    }

    return '';
  }

  @Watch('active')
  onActiveChanged(value: boolean) {
    this.$helpers.afterBrowserRedraw(() => {
      const scrollPanelDestination = this.$refs.scrollPanelDestination as any;
      //const scrollPanelWrapper = this.$refs.scrollPanelWrapper as any;

      if(scrollPanelDestination) {
        if(value) {
          scrollPanelDestination.addEventListener('scroll', this.onDialogScrollThrottled);
          //scrollPanelWrapper.addEventListener('scroll', this.onDialogScrollThrottled);
        } else {
          scrollPanelDestination.removeEventListener('scroll', this.onDialogScrollThrottled);
          //scrollPanelWrapper.removeEventListener('scroll', this.onDialogScrollThrottled);
        }
      }
    });
  }

  onDialogScroll() {
    this.bus.emit('dialog-scroll', 'campaigns-dialog');
  }

  get onDialogScrollThrottled() {
    return throttle(this.onDialogScroll, 70);
  }

  onChangeCountry() {
    this.setFlowOptions()
    this.setLandingOptions()
    this.setOfferOptions()
  }

  onChangeWorkspace(value: any) {
    const { flowInline, trackingDomainId, flow } = this.defaultForm();

    this.form = {
      ...this.form,
      flowInline,
      flow,
      trackingDomainId
    };
    this.setFlowOptions()
    this.setLandingOptions()
    this.setOfferOptions()
  }
  
  trackAnalytics(event,form){
    const {postbackPercent,trafficLossPercent, uniquenessPeriod, redirectMode, name} = form;
    let rules= [];
    
    if(form.destinationType==='flowInline'){
      rules= form.flowInline.rules.reduce((acc,rule)=>{
        Object.keys(rule.conditions).forEach((condition)=>acc.push(condition))
        return acc;
      },[])
    }
    
    this.$mixpanel?.track(event, {
      name,
      ...(form.usePostback && {'postback_percent': postbackPercent}),
      ...(form.useTrafficLoss && {'trafficLoss_percent': trafficLossPercent}),
      'uniqueness_period': uniquenessPeriod,
      ...((form.destinationType ==='flowInline'|| form.destinationType ==='flow') && {'redirect_mode': redirectMode}),
      ...(form.destinationType==='flowInline' && {rules})
    })
  }

  get showPlanLimitsWarning_rotation() {
    return this.form.rotation!=='random' && this.hasPlanLimitsRestriction('smartRotations')
  }

  get showPlanLimitsWarning_doubleMeta() {
    return this.form.redirectMode==='doubleMeta' && this.hasPlanLimitsRestriction('doubleMetaRedirect')
  }

}
